import React from 'react';
import { Helmet as ReactHelmet } from 'react-helmet';
import { graphql } from 'gatsby';

const Helmet = ({
  seo: { title, metaDescription, noIndex, noFollow, canonicalUrl, url },
  ogImage,
  children,
}) => {
  const isStaging = process.env.GATSBY_ENVIRONMENT === 'Staging';

  return (
    <ReactHelmet>
      <title>{title}</title>
      {metaDescription && <meta name="description" content={metaDescription} />}
      <meta
        name="robots"
        content={`${isStaging || noIndex ? 'noindex' : 'index'}, ${
          isStaging || noFollow ? 'nofollow' : 'follow'
        }`}
      />
      <link
        rel="canonical"
        href={`${process.env.GATSBY_SITE_URL}${
          canonicalUrl ? canonicalUrl : url
        }`}
      />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={metaDescription} />
      <meta
        property="og:url"
        content={`${process.env.GATSBY_SITE_URL}${
          canonicalUrl ? canonicalUrl : url
        }`}
      />
      <meta
        property="og:image"
        content={
          (ogImage && ogImage.url) ||
          `${process.env.GATSBY_SITE_URL}/images/og-image.png`
        }
      />
      {children}
    </ReactHelmet>
  );
};

export default Helmet;

export const HelmetFragment = graphql`
  fragment HelmetFragment on SPASEEKERS_Seo {
    title
    metaDescription
    noIndex
    noFollow
    canonicalUrl
    url
  }
`;
